import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const RegistrationDownArrow: React.FC<NormalIconProps> = ({ className }) => (
	<svg width="24" height="24" className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="Linear / Arrows / Alt Arrow Down">
			<path id="Vector" d="M19 9L12 15L5 9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</g>
	</svg>
);
